module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "new-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center text-sm-left"
  }, [_c('h4', [_vm._v("Our Products")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/patient"
    }
  }, [_vm._v("Patient")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Practice")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/academic"
    }
  }, [_vm._v("Academic")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center text-sm-left"
  }, [_c('h4', [_vm._v("Useful Links")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "id": "openPrivacyModal"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('privacy')
      }
    }
  }, [_vm._v("Privacy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "id": "openTermsModal"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('terms')
      }
    }
  }, [_vm._v("Terms and Conditions")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "id": "openPopiModal"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('popi')
      }
    }
  }, [_vm._v("Protection of Personal Information (POPI)")])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('popi-modal', {
    attrs: {
      "open": _vm.popiModalOpen
    },
    on: {
      "close": function($event) {
        return _vm.closeModal('popi')
      }
    }
  }), _vm._v(" "), _c('privacy-modal', {
    attrs: {
      "open": _vm.privacyModalOpen
    },
    on: {
      "close": function($event) {
        return _vm.closeModal('privacy')
      }
    }
  }), _vm._v(" "), _c('ud-terms-modal', {
    attrs: {
      "open": _vm.udTermsModalOpen
    },
    on: {
      "close": function($event) {
        return _vm.closeModal('udTerms')
      }
    }
  }), _vm._v(" "), _c('academic-terms-modal', {
    attrs: {
      "open": _vm.academicTermsModalOpen
    },
    on: {
      "close": function($event) {
        return _vm.closeModal('academicTerms')
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 text-center text-sm-left"
  }, [_c('img', {
    staticClass: "img-responsive center-sm-block",
    attrs: {
      "src": require("assets/images/footer_logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 text-center text-sm-left"
  }, [_c('h4', [_vm._v("Johannesburg Office")]), _vm._v(" "), _c('p', [_vm._v("Building 12"), _c('br'), _vm._v("\n          Woodmead Estate"), _c('br'), _vm._v("\n          1 Woodmead Drive"), _c('br'), _vm._v("\n          Woodmead")]), _vm._v(" "), _c('h4', [_vm._v("Pretoria Office")]), _vm._v(" "), _c('p', [_vm._v("46 Ingersol Road"), _c('br'), _vm._v("\n          Lynnwood Glen"), _c('br'), _vm._v("\n          Pretoria")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 text-center text-sm-left"
  }, [_c('h4', [_vm._v("Contact Us")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled "
  }, [_c('li', {
    staticClass: "m-b"
  }, [_c('a', {
    staticClass: "h4 m-t-0",
    attrs: {
      "href": "mailto:contact@logbox.co.za"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" contact@logbox.co.za")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "h4 m-b-0",
    attrs: {
      "href": "tel:+27822627238"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" 082 262 7238")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-elephant"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('a', {
    attrs: {
      "href": "http://www.groupelephant.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/Group_Elephant_Logo.svg")
    }
  }), _vm._v(" part of the groupelephant.com family")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74a0863c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FooterBar.vue
// module id = 664
// module chunks = 5